require('cross-fetch/polyfill');

const React = require('react');
const { IntlProvider, addLocaleData } = require('react-intl');
const { Mixin } = require('hops-mixin');
const { Helmet } = require('react-helmet');

class I18nMixin extends Mixin {
  constructor(config, element, { i18n: options = {} } = {}) {
    super(config);

    this.options = options;
  }

  bootstrap() {
    const serverData = this.getServerData();
    this.language = serverData.language;

    if (!this.language) {
      throw new Error('No language set.');
    }

    return import(
      /* webpackChunkName: "hops-language-[request]" */ `locales/${this.language}`
    ).then((locale) => {
      const { messages, localeData } = locale;
      this.messages = messages;
      this.localeData = localeData;
    });
  }

  configureFetch(fetch) {
    return (...fetchArgs) => {
      const request = new Request(...fetchArgs);
      request.headers.set('Accept-Language', this.language);

      return fetch(request);
    };
  }

  enhanceElement(reactElement) {
    addLocaleData(this.localeData);

    // in case the IntlProvider isn't rendered at top-level, we need to overwrite
    // this method to not have the IntlProvider block context updates from any
    // other components that may be wrapped around it.
    IntlProvider.prototype.shouldComponentUpdate = () => true;
    const providerOptions = this.options.intlProvider || {};

    return React.createElement(
      React.Fragment,
      {},
      React.createElement(
        Helmet,
        {},
        React.createElement('html', { lang: this.language })
      ),
      React.createElement(
        IntlProvider,
        {
          locale: this.language,
          messages: this.messages,
          textComponent: React.Fragment,
          ...providerOptions,
        },
        reactElement
      )
    );
  }
}

module.exports = I18nMixin;
